(function () {
  'use strict';
  if (window.BFStoryMarquee) return;
  var instances = new Map();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    if (instances.has(root)) return;
    var rows = Array.from(root.querySelectorAll('[data-bf-wall-row]'));
    var inView = false, hovered = false;
    var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
    function sync() { root.dataset.bfRunning = String(inView && !document.hidden && !hovered && !reduced.matches); }
    function hoverStart() { if (hoverCapable.matches) { hovered = true; sync(); } }
    function hoverEnd() { hovered = false; sync(); }
    function size() {
      rows.forEach(function (row) {
        var groups = Array.from(row.querySelectorAll('.bf-story-wall__group'));
        var first = groups[0];
        if (!first.children.length) return;
        first.querySelectorAll('[data-bf-repeat]').forEach(function (node) { node.remove(); });
        var originals = Array.from(first.children);
        var tile = originals[0].getBoundingClientRect().width;
        if (!(tile > 0) || !(root.clientWidth > 0)) return;
        // Keep a full viewport of content even when the editor leaves only one photo.
        while (first.getBoundingClientRect().width < root.clientWidth + tile) {
          var previousWidth = first.getBoundingClientRect().width;
          originals.forEach(function (node) { var copy = node.cloneNode(true); copy.dataset.bfRepeat = ''; copy.removeAttribute('data-shopify-editor-block'); copy.setAttribute('aria-hidden','true'); copy.querySelector('img').alt = ''; first.appendChild(copy); });
          // An unlaid-out container must not keep cloning forever (WebKit).
          if (!(first.getBoundingClientRect().width > previousWidth)) return;
        }
        groups.slice(1).forEach(function (group) {
          group.replaceChildren();
          Array.from(first.children).forEach(function (node) { var copy = node.cloneNode(true); copy.removeAttribute('data-shopify-editor-block'); copy.setAttribute('aria-hidden','true'); copy.querySelector('img').alt = ''; group.appendChild(copy); });
        });
        var cycle = first.getBoundingClientRect().width;
        var speed = (Number(root.dataset.bfSpeed) || 60) * tile / 458.255;
        var phase = row.dataset.bfWallRow === 'top' ? tile * 4.811776 : tile * .689573;
        var track = row.querySelector('.bf-story-wall__track');
        track.style.setProperty('--bf-wall-cycle', cycle + 'px');
        track.style.setProperty('--bf-wall-phase', (phase % cycle) + 'px');
        track.style.setProperty('--bf-wall-duration', cycle / speed + 's');
      });
    }
    var intersection = null, resize = null;
    function resizeFallback() { window.requestAnimationFrame(size); }
    if (window.IntersectionObserver) {
      intersection = new window.IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; sync(); });
      intersection.observe(root);
    } else { inView = true; sync(); }
    if (window.ResizeObserver) { resize = new window.ResizeObserver(resizeFallback); resize.observe(root); }
    else window.addEventListener('resize',resizeFallback);
    size();
    root.addEventListener('mouseenter',hoverStart);
    root.addEventListener('mouseleave',hoverEnd);
    document.addEventListener('visibilitychange',sync);
    if (reduced.addEventListener) reduced.addEventListener('change',sync);
    else if (reduced.addListener) reduced.addListener(sync);
    instances.set(root,function () { if (resize) resize.disconnect(); if (intersection) intersection.disconnect(); window.removeEventListener('resize',resizeFallback); root.removeEventListener('mouseenter',hoverStart); root.removeEventListener('mouseleave',hoverEnd); document.removeEventListener('visibilitychange',sync); if (reduced.removeEventListener) reduced.removeEventListener('change',sync); else if (reduced.removeListener) reduced.removeListener(sync); instances.delete(root); });
  }
  function initialize(scope) { scope.querySelectorAll('[data-bf-story-wall]').forEach(init); }
  window.BFStoryMarquee = { initialize: initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function () { initialize(document); }); else initialize(document);
  document.addEventListener('shopify:section:load',function (e) { initialize(e.target); });
  document.addEventListener('shopify:section:unload',function (e) { Array.from(instances).forEach(function (entry) { if (e.target.contains(entry[0])) entry[1](); }); });
})();
